/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useSettings } from '@/data/Settings';
import { ID } from '@/data/types/Basic';
import { ItnlIntegrationScript } from '@/data/types/ItnlIntegrationScript';
import { icecatLiveScript } from '@/utils/itnlIntegrationScriptsScripts';
import { loadExternalScripts, removeScripts } from '@/utils/loadExternalScripts';
import { Box } from '@mui/material';
import { FC, useEffect, useMemo, useState } from 'react';
import { getAttributeValueByIdentifier } from '@/utils/productAttributes';
import { EMPTY_STRING } from '../USPsDeliveryTerms';
import { useProduct } from '@/data/Content/Product';
import { ItnlIntegrationStyle } from '@/data/types/ItnlIntegrationStyle';
import { loadExternalStyles } from '@/utils/loadExternalStyles';
import { icecatLiveStyles } from '@/utils/itnlIntegrationStyles';

export const PdpEnrichedContentRv: FC<{ id: ID; }> = ({ id }) => {
	const { settings } = useSettings();
	const { product } = useProduct({ id: id.toString() });
	const [loadScript, setLoadScript] = useState(false);
	
	const {
		GTIN
	} = useMemo(()=>{
		const primaryEAN = getAttributeValueByIdentifier(product?.attributes, "PrimaryEAN");
		const barCodes = getAttributeValueByIdentifier(product?.attributes, "Ean13");
		return{
			GTIN: primaryEAN !== EMPTY_STRING ? primaryEAN : barCodes
		}
	},[product]);
	const APlusLegoVendorValue = useMemo(()=>settings.userData.APlusLegoVendor,[settings]);

	useEffect(() => {
		if (!loadScript && GTIN && GTIN!==EMPTY_STRING 
			&& APlusLegoVendorValue === 'IceCat')
		{
			const scripts: ItnlIntegrationScript[] = [
				{
					id: "icecatlive_enriched_content_script",
					url: " https://live.icecat.biz/js/live-current-2.js",
					onLoadScripts: [{
						id: "icecatlive_init_script",
						scriptContent: icecatLiveScript(GTIN),
					}],
					retainScript: true,
					skipIfExists: true
				}
			];
			loadExternalScripts(scripts);
			setLoadScript(true);
			
			const styles: ItnlIntegrationStyle[] = [
				{
					id: "container1",
					styleContent: icecatLiveStyles(),			 
					skipIfExists: true
				}
			];
       
	  		loadExternalStyles(styles);
			return () => { removeScripts(scripts) }
		}
	}, [loadScript, GTIN, APlusLegoVendorValue]);

	return (<Box id="IcecatLive" ></Box>);
};


